import React from "react";
import { Card, ProgressBar } from "react-bootstrap";

interface PointsAccumulatedCardProps {
  progressPercentage: number;
  startDate: string;
  endDate: string;
  daysRemaining: number;
  isCurrentWeek: boolean;
}

const PointsAccumulatedCard: React.FC<PointsAccumulatedCardProps> = ({
  progressPercentage,
  startDate,
  endDate,
  daysRemaining,
  isCurrentWeek,
}) => {
  const getProgressVariant = () => {
    if (progressPercentage >= 80) return "success";
    if (progressPercentage >= 50) return "warning";
    return "info";
  };

  return (
    <Card className="border-0 rounded-3 bg-white p-4 h-100">
      <h5 className="mb-3">Progreso Semanal</h5>
      <h2 className="mb-3">
        {progressPercentage}% 
        <small className="fs-6 text-muted"> completado</small>
      </h2>
      <p className="mb-2">Período actual:</p>
      <div className="d-flex align-items-center mb-2">
        <ProgressBar 
          now={progressPercentage} 
          style={{ height: '8px', width: '100%' }} 
          variant={getProgressVariant()}
        />
      </div>
      <div className="d-flex">
        <small className={isCurrentWeek ? "text-success" : "text-muted"}>
          {isCurrentWeek ? `${daysRemaining} días restantes` : "Período inactivo"}
        </small>
      </div>
      <div className="mb-2">
        <small className="text-muted">
          <strong>Inicio:</strong> {startDate}
        </small>
        <br />
        <small className="text-muted">
          <strong>Fin:</strong> {endDate}
        </small>
      </div>
    </Card>
  );
};

export default PointsAccumulatedCard;
